import { AppAlert, AppCard, AppLoadingSpinner } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useOpportunitySummary } from '@opportunities/-hooks/useOpportunitySummary'
import { DateTime } from 'luxon'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

export function OpportunitySalesSummaryChart() {
  // 当月の日付を取得（YYYY-MM-DD形式）
  const startAt = DateTime.local().toFormat('yyyy-MM-dd')

  // サマリーデータを取得
  const { data, isLoading, error } = useOpportunitySummary({
    startAt,
  })

  // ローディング中
  if (isLoading) {
    return (
      <AppCard title='月間オポ売上TOP10'>
        <div className='h-64 flex items-center justify-center'>
          <AppLoadingSpinner text='読み込み中...' size='small' />
        </div>
      </AppCard>
    )
  }

  // エラー時
  if (error) {
    return (
      <AppCard title='月間オポ売上TOP10'>
        <div className='h-64 flex items-center justify-center'>
          <AppAlert type='error'>
            データの取得に失敗しました。
            {error.message && <div className='mt-1 text-xs opacity-80'>{error.message}</div>}
          </AppAlert>
        </div>
      </AppCard>
    )
  }

  const summaries = data?.summaries ?? []

  // データが空の場合
  if (summaries.length === 0) {
    return (
      <AppCard title='月間オポ売上TOP10'>
        <div className='h-64 flex items-center justify-center text-muted-foreground'>データがありません</div>
      </AppCard>
    )
  }

  // TOP10を抽出してチャート用データに変換（売上0円は除外）
  const chartData = summaries
    .sort((a, b) => b.totalSales - a.totalSales)
    .slice(0, 10)
    .filter((summary) => summary.totalSales > 0)
    .map((summary) => ({
      name: `${summary.memberName}_${summary.memberEmployeeNumber ?? ''}`,
      売上金額: summary.totalSales,
    }))

  return (
    <AppCard title='月間オポ売上TOP10'>
      <ResponsiveContainer width='100%' height={300}>
        <BarChart data={chartData} margin={{ left: 20, right: 10, top: 10, bottom: 10 }}>
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='name' angle={-45} textAnchor='end' height={100} fontSize={12} />
          <YAxis
            width={80}
            label={{ value: '売上金額', angle: -90, position: 'insideLeft', offset: 10 }}
            tickFormatter={(value) => `¥${(value / 10000).toLocaleString()}万`}
            fontSize={12}
          />
          <Tooltip formatter={(value) => `¥${Number(value).toLocaleString()}`} />
          <Bar dataKey='売上金額' fill='#3b82f6' barSize={40} />
        </BarChart>
      </ResponsiveContainer>
    </AppCard>
  )
}
